<template>
    <div class="stateInventory responsive-menu">
      <div class="responsive-menu__child">
        <PageHeader
          title="Customer Loyalty Status"
          :links="[
            { name: 'home', label: 'Home' },
            { name: 'reports', label: 'Reports' },
            { name: 'customerReport', label: 'Customer' },
            {
              name: 'customerLoyaltyStatus',
              label: 'Customer Loyalty Status',
            },
          ]"
          @export="exportToCsv"
          :disableExport="!reportData"
        />
        <br class="no-print" />
        <ReportFilter
          class="no-print"
          :filterByCustomerLoyalty="true"
          @submit-filter="performGetReport"
          :isLoading="customerTransactions"
        />
        <div class="report-container">
          <!-- This could be a component -->
          <div class="report-body" v-if="reportData">
            <table id="table-report">
              <thead>
                <tr class="report-body__row report-body__row--header"></tr>
                <tr>
                  <th align="left">Id</th>
                  <th align="left">Customer</th>
                  <th align="left">Email</th>
                  <th align="left">Discount %</th>
                  <th align="left">Employee</th>
                  <th align="left">Veteran</th>
                  <th align="left">CCP</th>
                  <th align="left">Loyalty Program</th>
                </tr>
              </thead>

              <tbody>
                <tr class="report-body__row"></tr>
                <tr v-for="(record, index) in reportData.records" :key="index">
                  <td>{{ record.id }}</td>
                  <td>{{ record.fullNameOpposite }}</td>
                  <td>{{ record.email }}</td>
                  <td>{{ record.saleDiscountPercentage }}</td>
                  <td>{{ record.isEmployee ? 'Y' : 'N' }}</td>
                  <td>{{ record.isVeteran ? 'Y' : 'N' }}</td>
                  <td>{{ record.isCCP ? 'Y' : 'N' }}</td>
                  <td>{{ record.isInLoyaltyProgram ? 'Y' : 'N' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import PageHeader from "@/components/Header/Header.vue";
  import ReportHelper from "@/lib/report/index.js";
  import { mapActions, mapGetters } from "vuex";
  import ReportFilter from "@/components/ReportFilter/ReportFilter";
  import Utilities from "@/lib/Utilities";

  export default {
    data() {
      return {
        reportData: undefined,
        Utilities,
        reportType: undefined,
        selectedPeriod: undefined,
        selectedReportFor: undefined,
        selectedReportSaleType: undefined,
        filterDropdown: undefined,
      };
    },
    components: {
      PageHeader,
      ReportFilter,
    },
    created: function () {
      this.setPageTitle("Customer Loyalty Status");
    },
    mounted: function () {
      const today = new Date();
      this.selectedPeriod = {
        from: new Date(new Date().setDate(today.getDate() - 7)),
        to: today,
      };
    },
    computed: {
      ...mapGetters({
        loadingStatus: "reports/loadingStatus",
        customerTransactions: "reports/customerTransactions",
      }),
    },
    methods: {
      ...mapActions({
        getSalesTransactions: "reports/getCustomerTransactions",
      }),
      performGetReport(filter) {
        let reportType = "customerLoyaltyStatus";
        this.getSalesTransactions({
          reportType,
          ...filter,
          positiveCallback: (data) => {
            this.reportData = data;
          },
        });
      },
      exportToCsv() {
        var table = document.getElementById("table-report");
        ReportHelper.exportToExcel(table, "customerLoyaltyStatus");
      },
    },
  };
  </script>

  <style lang="scss">
  @import "./_customerLoyaltyStatus.scss";